export const FEEDBACK_COLLECTOR_ENTRYPOINT_ID = '45c9c029-3180-4960-ab0d-db7cdeaf5f54';
export const MS_IN_SECOND = 1000;
export const SECONDS_IN_MIN = 60;
export const SECONDS_IN_HR = SECONDS_IN_MIN * 60;
export const LS_PROVIDER_KEY = 'aiMateSmartLinkProviders';
export const LS_CHAT_LOAD_PREFERENCE_KEY = 'aiMateChatLoadPreference';
export const AI_MATE_EXPERIENCE_ID = 'ai-mate';
export const DIRECTORY_URL = '/gateway/api/directory/graphql';
/** 30 minutes in milliseconds */
export const TIMEOUT_BEFORE_NEW_CHAT = 30 * SECONDS_IN_MIN * MS_IN_SECOND;
/** 5 minutes in milliseconds */
export const SHORTER_TIMEOUT_BEFORE_NEW_CHAT = 5 * SECONDS_IN_MIN * MS_IN_SECOND;
export const LS_LAST_MESSAGE_SENT_AT = 'rovoChatLastMessageSentAt';
/**
 * If you are updating this, please also update the pollinator repo so it will not fail during transition period
 * https://bitbucket.org/atlassian/pm2-ai-mate
 */
/**
 * Height of the greeting header in mini modal (in pixels).
 * Used to adjust minimum height calculation so users can resize below
 * the initial height when greeting is visible.
 */
export const MINI_MODAL_GREETING_HEIGHT = 140;

export const POLLINATOR_TEST_IDS = {
	NEW_CHAT_BUTTON: 'rovo-chat-new-chat-button',
	THUMBS_UP_BUTTON: 'rovo-chat-thumbs-up-button',
};
